<script>
export default {
  props: {
    ratePlan: { type: Object, required: true },
    room: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    cancellation() {
      return this.ratePlan.promotion
        ? this.ratePlan.promotion.cancellation
        : this.ratePlan.cancellationId
    },
  },
}
</script>

<template>
  <div>
    <strong
      v-if="index === 0 && room.ratePlans.length > 1"
      class="block bg-orange-500 text-sm text-white px-3 py-1"
    >
      Lowest price available!
    </strong>
    <div class="px-3 my-3">
      <span class="font-medium text-sm">{{ ratePlan.name }}</span>
      <ul>
        <li class="flex text-sm">
          <BaseIcon class="text-green-600 mr-3" name="check" />
          <span>Free breakfast for {{ ratePlan.occupancy.included }}</span>
        </li>
        <li v-if="ratePlan.benefits.length" class="flex text-sm">
          <BaseIcon class="text-green-600 mr-3" name="check" />
          <span>{{ ratePlan.benefits.join(', ') }}</span>
        </li>
        <li v-if="room.information.wifiIncluded" class="flex text-sm">
          <BaseIcon class="text-green-600 mr-3" name="check" />
          <span>Free Wi-Fi</span>
        </li>
        <li class="flex text-sm">
          <BaseIcon class="text-green-600 mr-3" name="check" />
          <span>{{ ratePlan.cancellation }}</span>
        </li>
      </ul>
      <div v-if="ratePlan.promotion" class="flex mt-2 text-xs">
        <div
          class="flex-col inline-flex bg-blue-900 text-white px-2 py-1 rounded"
        >
          <div>
            <BaseIcon name="clock" />
            {{ ratePlan.promotion.tag }}
          </div>
          <BaseCountdown
            v-if="ratePlan.promotion.timer"
            :end-date="new Date(ratePlan.promotion.timer)"
          />
        </div>
        <div class="inline-block bg-blue-100 px-2 py-1 text-blue-800">
          {{ ratePlan.promotion.percentDisc }}% discount
        </div>
      </div>
    </div>
  </div>
  <!-- benefit column -->
</template>
